// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy, LoadablePaint } from '@confluence/loadable';

import { PresentationModePlaceholder } from './PresentationModePlaceholder.tsx';

export const PresenterModeContextProvider: LoadableType<{
	children: React.ReactNode;
	contentId: string;
	spaceKey: string;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PresenterModeContext" */ './PresenterModeContextProvider.tsx'
			)
		).PresenterModeContextProvider,
});

export const LazyPresenterModeContextConsumer: LoadableType<{
	children: (enterPresenterMode: () => void) => React.ReactNode;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PresenterModeContext" */ './PresenterModeContextProvider.tsx'
			)
		).PresenterModeContextConsumer,
	loading: () => <PresentationModePlaceholder />,
});

export { usePresenterModeContext } from './PresenterModeContext.tsx';
